/**
 * Which method to use to update the URL
 */
export const enum BrowserLocationUpdateMethodEnum {
  push = 'push',
  replace = 'replace',
  redirect = 'redirect',
}
